import { Box, Button } from "@mui/material";
import DetailDialog from "common/components/DetailDialog";
import { useTranslation } from "common/locales";
import type { AnimalGroup, StockClass } from "model";
import { Link } from "react-router-dom";
import RotationSeasonGrid from "./RotationSeasonGrid";

export function RotationTimelineButton({
  animalGroupId,
}: {
  animalGroupId: string;
}) {
  const { t } = useTranslation();
  return (
    <Button
      variant="outlined"
      color="primary"
      component={Link}
      to={`/animal-group/${animalGroupId}/rotations`}
      sx={{ width: "100%", mt: 1 }}
    >
      {t("animalGroup.viewRotations")}
    </Button>
  );
}

export function RotationTimelineDialog({
  open,
  close,
  animalGroupId,
  animalGroupName,
  animalGroup,
  stockClasses,
}: {
  open: boolean;
  close: () => void;
  animalGroupId: string;
  animalGroupName: string;
  animalGroup?: AnimalGroup;
  stockClasses?: StockClass[];
}) {
  const { t } = useTranslation();
  const dialogTitle = (
    <>
      <Box component="span" sx={{ color: "text.secondary", fontWeight: 400 }}>
        {t("rotationTimeline.title")}:{" "}
      </Box>
      {animalGroupName}
    </>
  );

  return (
    <DetailDialog
      open={open}
      onClose={close}
      title={dialogTitle}
      contentSx={{ backgroundColor: "#F7FCF1" }}
    >
      {open && (
        <RotationSeasonGrid
          animalGroupId={animalGroupId}
          animalGroup={animalGroup}
          stockClasses={stockClasses}
        />
      )}
    </DetailDialog>
  );
}
